/**
 * Turn a registration failure into something the person reading it can act on.
 *
 * The two failures that actually happen during an invited signup both used to
 * surface as raw Firebase text: "permission-denied" when the invitation could
 * not be matched, and "The email address is already in use by another account."
 * on the retry that follows it. Neither tells the person what to do, and the
 * first one is exactly how the Fixbrigade Amersfoort lockout stayed invisible
 * for a day. See docs/inbox.md Bug #137.
 *
 * Anything we do not recognise keeps its original text — a real outage must not
 * be smoothed away into a friendly sentence.
 *
 * @param {{code?: string, message?: string} | undefined} error - The rejected error
 * @param {string} email - The address the person registered with
 * @returns {string} Message to show
 */
const registrationErrorMessage = (error, email) => {

    const code = String(error?.code || '')
    const address = email || 'dit e-mailadres'

    // The Cloud Function rejects with permission-denied when no pending
    // invitation matches the account that was just created. Match the exact
    // codes a callable produces — a loose `endsWith` would also catch
    // `storage/permission-denied` and then confidently blame a missing
    // invitation for something else entirely.
    const NO_INVITATION_CODES = ['permission-denied', 'functions/permission-denied']

    if (NO_INVITATION_CODES.includes(code)) {
        return `Er staat voor ${address} geen uitnodiging klaar in deze omgeving. `
            + `Gebruik het e-mailadres waarop je de uitnodiging hebt ontvangen, `
            + `of vraag de beheerder van de omgeving om een nieuwe uitnodiging.`
    }

    if (code === 'auth/email-already-in-use') {
        return `Er bestaat al een account met ${address}. `
            + `Ga naar het inlogscherm en klik op 'Wachtwoord vergeten? Klik hier.' als je je wachtwoord kwijt bent.`
    }

    return error?.message || 'Er ging iets mis bij het aanmaken van je account.'
}

export default registrationErrorMessage
